var angular = require('angular');

var util = require('js/lib/util');
var File = require('js/lib/file');
var fileUploadTemplate = require('html/templates/fileUpload')();
var productsInFileTemplate = require('html/templates/productsInFile')();
var suggestedRoutesTemplate = require('html/templates/suggestedRoutes')();
var optimizeTemplate = require('html/templates/optimize')();
var t = require('js/lib/translate').t;

planCustomersCtrl.$inject = ['$scope', '$controller', '$routeParams', '$location', '$timeout',
                             '$document', '$filter', 'modal', 'load', 'storage', 'serverError', 'editCustomer'];

function planCustomersCtrl($scope, $controller, $routeParams, $location, $timeout,
                           $document, $filter, modal, load, storage, serverError, editCustomer) {

  $controller('planCtrl', { $scope: $scope });

  $scope.activeTab =
    $location.hash() ||
    ($scope.page === 'plan-files' && 'files') ||
    'all';


  $scope.filter = {
    latitude: $location.hash() === 'deviation' ? null : undefined
  };

  $scope.search = {
    text: undefined
  };

  $scope.setFileFilter = function(fileId) {
    if (fileId == null) {
      $scope.filter.fileId = undefined;
    } else {
      $scope.filter.fileId = +fileId || fileId;
    }
  };

  $scope.setFileFilter($routeParams.fileId);


  $scope.allFiles = function() {
    var hasIndividual = $scope.routePlan.customers.some(function(customer) {
      return customer.fileId === File.individual.id;
    });

    return hasIndividual
      ? [].concat($scope.routePlan.files, File.individual)
      : $scope.routePlan.files;
  };

  $scope.customersInFile = function(file) {
    return $filter('filter')($scope.routePlan.customers, { fileId: file.id });
  };


  $scope.customersLink = function(hash) {
    var link = $scope.router.link('plan/customers', $scope.routePlan.id);

    if ($scope.filter.fileId != null) link += '/' + $scope.filter.fileId;
    if (hash) link += '#' + hash;

    return link;
  };


  $scope.openFileUpload = function() {
    $scope.newFile = {};

    // Prepopulate customer system if only one
    var custSysArr = $scope.values($scope.customerSystems);
    if (custSysArr.length === 1) {
      $scope.newFile.customerSystemId = custSysArr[0].id;
    }

    modal.open({
      scope: $scope,
      klass: 'file-upload',
      title: t('fileModalHeader'),
      body: fileUploadTemplate
    });
  };

  $scope.saveFile = function(file) {
    $scope.closeModal();

    load.createFile($scope.routePlan.id, file.customerSystemId, file.file.name).then(function(data) {
      load.uploadFile(data.id, file.file).catch(function(error) {
        if (error.ignoredStatus === 400) {  // 400 Bad request
          load.deleteFile(data);
          serverError.error(null, null, {
            errorKey: '"' + file.file.name + '":',
            errorMap: data.errorMessage(error.data && error.data.errorKey, error.data && error.data.errorMap)
          }, 'fileStatus_error');
        }
      });
    });
  };

  $scope.deleteFile = function(file) {
    modal.open({
      scope: $scope,
      title: t('planFilesDeleteFile'),
      body: t('planFilesDeleteFileConfirm', file.name),
      onConfirm: function() {
        load.deleteFile(file);
      }
    });
  };

  $scope.openProducts = function(routePlan, file) {
    var customerInFile = routePlan.customers
      .filter(function(customer) {
        return customer.fileId === file.id;
      });

    $scope.products = util.aggregateProductsForCustomers(customerInFile);

    modal.open({
      scope: $scope,
      klass: 'products-in-file',
      title: t('productsModalHeader'),
      body: productsInFileTemplate
    });
  };

  $scope.openSuggestedRoutes = function(routePlan) {
    $scope.suggestedRoutes = routePlan.suggestedRoutes;

    modal.open({
      scope: $scope,
      klass: 'suggested-routes',
      title: t('suggestedRoutesModalHeader'),
      body: suggestedRoutesTemplate
    });
  };

  // EditCustomer-service (mappings)
  $scope.openEditCustomer = editCustomer.openEditCustomer.bind(this, $scope);
  $scope.saveCustomer = editCustomer.saveCustomer.bind(this, $scope);
  $scope.addDelivery = editCustomer.addDelivery.bind(this);
  $scope.deleteDelivery = editCustomer.deleteDelivery.bind(this);
  $scope.cancelDelivery = editCustomer.cancelDelivery.bind(this, $scope);
  $scope.undoCancelDelivery = editCustomer.undoCancelDelivery.bind(this, $scope);
  $scope.deleteCustomer = editCustomer.deleteCustomer.bind(this, $scope);
  $scope.cancelCustomer = editCustomer.cancelCustomer.bind(this, $scope);
  $scope.openMap = editCustomer.openMap.bind(this, $scope);

  $scope.activeCustomerId = null;


  $scope.timePattern = /^([01][0-9]|2[0-3]):?[0-5][0-9]$/;
  $scope.integerPattern = /^[1-9]\d*$/;
  $scope.travellers = ['car', 'pedestrian'];

  $scope.openOptimize = function(optimizeRoutes) {
    $scope.optimizeRoutes = optimizeRoutes;
    $scope.optimize = storage.local.get('optimize') || {};
    if (! optimizeRoutes) {
      $scope.optimize.type = 'time'; // Show time-interval when not optimizing
    }
    $scope.optimize.date = $scope.routePlan.date;
    $scope.optimize.type = $scope.optimize.type || 'time';
    $scope.optimize.showTraveller = $scope.settings.customerSystemSettings && $scope.settings.customerSystemSettings.some(function(css) {
      return css.showTraveller;
    });
    $scope.optimize.traveller = $scope.optimize.traveller || 'car'; // Default car (if never selected before)
    $scope.optimize.pickupLocations = $scope.optimize.pickupLocations || [];
    $scope.optimize.countWarnings =
      $filter('filter')($scope.routePlan.customers, { latitude: null }).length;

    $scope.validateStartStopInterval = function(optimize) {
      var start = util.toTime(optimize.start);
      var stop = optimize.type === 'time' && util.toTime(optimize.stop);

      if (start && stop && start >= stop) {
        $scope.form.stop.$setValidity('interval', false);
      } else {
        $scope.form.stop.$setValidity('interval', true);
      }
    };

    initPickupLocations($scope.optimize);

    var title = t(optimizeRoutes ? 'optimizeModalHeaderOptimize' : 'optimizeModalHeaderCreateRoutes');

    modal.open({
      scope: $scope,
      klass: 'optimize',
      title: title,
      body: optimizeTemplate
    });
  };

  $scope.saveOptimization = function(optimize, optimizeRoutes) {

    var startOptimization = function() {
      var data = {
        date: util.toDateNoon(optimize.date),
        pickupLocations: optimize.pickupLocations,
        limits: {
          start: util.toDateWithTime(optimize.date, optimize.start),
          stop: optimize.type === 'time' ? util.toDateWithTime(optimize.date, optimize.stop) : null,
          routeCount: optimize.type === 'routes' ? +optimize.routeCount : null,
          capacityPerRoute: optimize.type === 'routes' ? optimize.capacityPerRoute : null,
          cluster: optimize.cluster || false,
          traveller: optimize.traveller,
          returnToPickupLocation: optimize.returnToPickupLocation || false,
          optimizeRelocate: optimize.relocate
        }
      };

      storage.local.set('optimize', {
        type: optimize.type,
        start: util.toTime(optimize.start),
        stop: util.toTime(optimize.stop),
        routeCount: data.limits.routeCount,
        capacityPerRoute: data.limits.capacityPerRoute,
        cluster: data.limits.cluster,
        traveller: data.limits.traveller,
        returnToPickupLocation: data.limits.returnToPickupLocation,
        pickupLocations: optimize.pickupLocations
      });

      if (optimizeRoutes) {
        load.startOptimization($scope.routePlan.id, data).then(function() {
          $scope.closeModal();
          $location.hash(null).path($scope.router.link('plans'));
        }).catch(function(error) {
          if (error.ignoredStatus === 417) {
            msg = $scope.routePlan.errorMessage(error.data.errorKey, $scope.settings.boundaryBox);
            //console.log('msg', msg);
            serverError.error(null, null, {
              errorMap: msg.message,
              link: msg.link
            }, msg.title);
          }
        });
      } else {
        load.createSuggestedRoutes($scope.routePlan.id, data).then(function() {
          $scope.closeModal();
          $location.hash(null).path($scope.router.link('plans'));
        }).catch(function(error) {
          if (error.ignoredStatus === 417) {
            msg = $scope.routePlan.errorMessage(error.data.errorKey, $scope.settings.boundaryBox);
            //console.log('msg', msg);
            serverError.error(null, null, {
              errorMap: msg.message,
              link: msg.link
            }, msg.title);
          }
        });
      }
    };

    var complete = optimize.pickupLocations.every(function(location) {
      return location.latitude;
    });

    if ($scope.form.$invalid || ! optimize.pickupLocations.length || ! complete || $scope.optimize.editMode()) {
      return;
    }

    var warning = '';
    if (optimize.type === 'time') {
      var startTimestamp = util.toDateWithTime(optimize.date, optimize.start);
      var stopTimestamp = util.toDateWithTime(optimize.date, optimize.stop);

      var outside = $scope.routePlan.customers.filter(function(customer) {
        return customer.outsideDeliveryWindow(startTimestamp, stopTimestamp);
      });

      if (outside.length) {
        warning = t('optimizeModalTimeWindowOutsideError', outside.length);
      }
    }

    var title = t(optimizeRoutes ? 'optimizeModalHeaderOptimize' : 'optimizeModalHeaderCreateRoutes');
    var body = optimizeRoutes ? warning + t('optimizeModalConfirmOptimize') : warning + t('optimizeModalConfirmCreateRoutes', $scope.routePlan.suggestedRoutesCount());

    modal.open({
      scope: $scope,
      title: title,
      body: body,
      onConfirm: startOptimization
    });
  };

  var initPickupLocations = function(optimize) {

    var closeAddressHelper = function() {
      angular.element($document[0].getElementById('address-helper')).remove();
      optimize.index = undefined;
      optimize.pickupLocation = undefined;
    };

    var displayAddressHelper = function(index, location) {

      var display = function() {
        optimize.index = index;
        optimize.pickupLocation = location ? angular.copy(location) : {};
      };

      if (optimize.pickupLocation) {
        closeAddressHelper();
        $timeout(display);
      } else {
        display();
      }
    };

    var displayAddresses = function() {
      if (optimize.pickupLocations.length < 2) {
        displayAddressHelper(0, optimize.pickupLocations[0]);
      } else {
        closeAddressHelper();
      }
    };

    optimize.toggleClusterInfo = function() {
      angular.element($document[0].getElementById('cluster-info')).toggleClass('hide');
    };

    optimize.toggleRelocateInfo = function() {
      angular.element($document[0].getElementById('relocate-info')).toggleClass('hide');
    };

    optimize.toggleCarsTimeWindowInfo = function() {
      angular.element($document[0].getElementById('carstimewindow-info')).toggleClass('hide');
    };

    optimize.updateAddress = function(complete, address) {
      if (! address) return;
      delete address.suggestedRoute; // Cleanup for API
      optimize.pickupLocation = address;
      if (! optimize.editMode()) {
        optimize.pickupLocations.splice(0, 1, address);
      }
    };

    optimize.displayAddress = function(address) {
      return address.address + ', ' + util.formatZip(address.zip, address.country) + ' ' + address.city;
    };

    optimize.editMode = function() {
      return optimize.pickupLocation && (optimize.index > 0 || optimize.pickupLocations.length > 1);
    };

    optimize.newPickupLocation = function() {
      displayAddressHelper(optimize.pickupLocations.length);
    };

    optimize.editPickupLocation = function(index) {
      displayAddressHelper(index, optimize.pickupLocations[index]);
    };

    optimize.savePickupLocation = function() {
      optimize.pickupLocations.splice(optimize.index, 1, optimize.pickupLocation);
      displayAddresses();
    };

    optimize.cancelPickupLocation = function() {
      displayAddresses();
    };

    optimize.deletePickupLocation = function(index) {
      modal.open({
        scope: $scope,
        title: t('optimizeModalPickupPointDelete'),
        body: t('optimizeModalPickupPointDeleteBody', optimize.displayAddress(optimize.pickupLocations[index])),
        onConfirm: function() {
          optimize.pickupLocations.splice(index, 1);
          displayAddresses();
        }
      });
    };

    displayAddresses();
  };


}

module.exports = planCustomersCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controllers/planCustomersCtrl.js
 ** module id = 131
 ** module chunks = 1
 **/